


import { Component, Prop, Vue } from "vue-property-decorator";

import { ApiKeys } from "App";
import { $t } from "App/IOC";
import { Activated, Identifiable, Named } from "App/Contracts";
import { ApiKey } from "App/Models/ApiKey";

import PopupWindow from "Web/Components/Popup/Window.vue";

import TokenBlock from "./TokenBlock.vue";

/* AFFICHER UNE CLEF — le jeton est lu a l'ouverture ( `read` ), et a ce
   moment-la seulement ; il vit dans cette fenetre et disparait avec elle. */
@Component({
    components: {
        PopupWindow,
        TokenBlock
    }
})
export default class ApiKeyReveal extends Vue {
    @Prop()
    readonly Record!: ApiKey;

    private token: string = "";
    private loading: boolean = true;
    private failed: boolean = false;

    private closeAction: Identifiable & Named & Activated = {
        Id: "close",
        Name: $t( "API_KEYS_close" ),
        Active: true
    };

    async created(): Promise<void> {
        const [ token, error ] = await ApiKeys.Read( this.Record.Id );

        this.loading = false;
        this.failed = ( error !== undefined ) || ( token === undefined );
        this.token = token || "";
    }

    beforeDestroy(): void {
        this.token = "";
    }
}
